<template>
	<div class="login_box">
		<div class="p_flex p_box ">
			<div class="one_left">
          <div class="one_left-tiw">
              <img style="width: 100%;height: 100%;"  src="../../assets/img/Boss_Two Color.png"/>
          </div>
			</div>
			<div class="one_two  ">
				<div>
					<span class="p_flex p_m_a_a p_m_a_b subject_color type_size_30 ">修改密码</span>
				</div>
				<div class="two_box">
					<div class="p_flex p_login p_f_a" v-show="id=='ChangePassword'?true:false">
						<span class="p_m_l_30 type_size_18 ">原密码</span>
						<div class="p_f_1 p_m_l_30 type_size_18  p_m_r_30">
							<el-input type="password"  v-model="account" placeholder="请输入原密码"></el-input>
						</div>
					</div>
					<div class="p_flex p_login p_f_a p_m_t_30">
						<span class="p_m_l_30 type_size_18 ">新密码</span>
						<div class="p_f_1 p_m_l_30 type_size_18  p_m_r_30">
							<el-input type='password'  v-model="password" placeholder="请输入新密码"></el-input>
						</div>
					</div>
					<div class="p_flex p_login p_f_a p_m_t_30">
						<span class="p_m_l_30 type_size_18 ">确认密码</span>
						<div class="p_f_1 p_m_l_30 type_size_18  p_m_r_30">
							<el-input type='password'  v-model="passwordNew" placeholder="请再次输入新密码"></el-input>
						</div>
					</div>
				</div>
				<div class="p_m_t_70">
					<div class="two_com ">
						<el-button type="success" @click="goLogin()">确认</el-button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Amend',
		data() {
			return {
				account: '',
				password: '',
				passwordNew:'',
        		id:""
			}
		},
    created(){
        // console.log(this.$route.query.id)
        this.id=this.$route.query.id
    },
		methods: {
			goLogin() {
          if(!this.password || !this.passwordNew){
                this.$message.error("密码不能为空！")
                return
          }
          if(this.id=="ChangePassword"){
              this.$request.ajax(this).post("/api/update_password",{
                   old_password:this.account, //旧密码
                   password:this.password   //新密码
              }).then(res=>{
                // console.log(res)
                this.$router.push('/Login')  //跳转登录
                // this.$store.commit('logouts');
              })
              return
          }else{
              this.$request.ajax(this).post("/api/forget_password",{   //用手机号修改密码
                    id:this.id.id,
                    password:this.password,
                    user_type:this.id.user_type,
                    encryption:this.id.encryption
              }).then(res=>{
                // console.log(res)
                this.$router.push({
					path:"Login",
					query:{
						id:localStorage.getItem("userInfo")
					}
				})
              })
              return
          }
			},
		}
	}
</script>

<style lang="scss" scoped>
  .one_left {
  	width: 50%;
  	background-color: #fafafa;
  	border-radius: 20px 0px 0px 20px;
  }
  .one_left .one_left-tiw {
  	width: 80%;
  	margin: 15% auto 0;
  }

  .p_m_a_a{
  	margin-top: 10%;
  }

  .p_m_a_b{
  	margin-left: 15%;
  }

  .p_m_a_c{
  	margin-left: 5%;
  }


  .p_m_a_d{
  	margin-right: 5%;
  }

  .two_box{
  	width: 70%;
  	margin: 10% auto 0;
  }

  .p_login{
  	width: 100%;
  }

  .one_two {
  	 width: 50%;
  	background: #ffffff;
  	border-radius: 0px 20px 20px 0px;
  }

  .p_m_t_a{
  	margin-top: 20%;
  }

  .p_m_t_b{
  	margin-top: 15%;
  }

  .two_com {
  	width: 50%;
  	margin: 0 auto;
  }

  .two_log {
  	width: 40%;
  	margin: 10% auto 0;
  	// background: #0000FE;
  	// margin: 100px auto 0;
  }

  .el-button--success {
  	width: 100%;
  	margin: 0 auto;
  }
  .el-button {
  	border-radius: 20px;
  	font-size: 22px;
  	padding: 20px;
  }
  .footer {
  	display: flex;
  	justify-content: center;
  	font-size: 16px;
  	margin-top: 50px;
  }
  .login_box {
  	position: absolute;
  	top: 50%;
  	left: 50%;
  	transform: translate(-50%, -50%);
  	width: 60%;
  	height: 85%;
  }
  img {
  	width: 100%;
  	height: auto;
  	object-fit: cover;
  }
  .p_box{
  	width: 100%;
  	height: 80%;
  }
  >>> .el-input__inner {
  	border: none;
  	background-color: #f5f5f5;
  	font-size: 18px;
  	color: #333;
  	padding: 0;
  }

  >>> input::-webkit-input-placeholder {
  	font-size: 18px;
  }


  .footer{
  	display: flex;
  	justify-content: center;
  	font-size: 16px;
  	margin-top: 50px;
  }



  >>> input::-webkit-input-placeholder {
  	font-size: 18px;
  }

  >>> input::-webkit-outer-spin-button,
  >>> input::-webkit-inner-spin-button {
  	-webkit-appearance: none;
  }

  >>> input[type='number'] {
  	-moz-appearance: textfield;
  }


  .yan_code {
  	color: #999999;
  }
</style>



// WEBPACK FOOTER //
// src/components/login/amend.vue